import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const BookingSuccessfullyCompleted = ({ coachPersonalLink }) => {
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                minHeight: "calc(100vh)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                gap: "20px",
            }}
        >
            <Box>
                <Typography
                    sx={{
                        fontSize: "16px",
                        lineHeight: "31px",
                        textAlign: "center",
                        fontFamily: "var(--font-grenettepromedium)",
                    }}
                >
                    {t("individual.booking.schedule.booking_completed")}
                </Typography>

                <Typography
                    sx={{
                        fontSize: "14px",
                        lineHeight: "16px",
                        textAlign: "center",
                    }}
                >
                    {t("individual.booking.schedule.booking_completed.description")}
                </Typography>
            </Box>

            <Box>
                <Button onClick={() => (window.location.href = coachPersonalLink)}>
                    {t(
                        "individual.booking.schedule.choose_schedule.button.coach_packages"
                    )}
                </Button>
            </Box>
        </Box>
    );
};

export default BookingSuccessfullyCompleted;